import './components/responsive-background-image';
import './components/screensaver';

(function ($, window) {

    // Add 'not-empty' class if input field has value
    //-----------------------------------------------

    $('textarea, input').each(function () {
        function toggleNotEmpty() {
            $(this).closest('.form-group').toggleClass('not-empty', $(this).val() !== '');
        }

        $(this)
        .each(toggleNotEmpty)
        .blur(toggleNotEmpty)
        .focus(function() {
            $(this).closest('.form-group').addClass('not-empty');
        });
    });

})(jQuery, window, document);


